/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Properties that define the availability of an operation.
 * @export
 * @interface AvailableOperation
 */
export interface AvailableOperation {
    /**
     * Indicates whether the operation is available. When the value is set to true, the operation is available. When set to false, the operation isn't available. The default value is false.
     * @type {boolean}
     * @memberof AvailableOperation
     */
    available?: boolean;
    /**
     * Name of the operation.
     * @type {string}
     * @memberof AvailableOperation
     */
    name?: string;
}

/**
 * Check if a given object implements the AvailableOperation interface.
 */
export function instanceOfAvailableOperation(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AvailableOperationFromJSON(json: any): AvailableOperation {
    return AvailableOperationFromJSONTyped(json, false);
}

export function AvailableOperationFromJSONTyped(json: any, ignoreDiscriminator: boolean): AvailableOperation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'available': !exists(json, 'available') ? undefined : json['available'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function AvailableOperationToJSON(value?: AvailableOperation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'available': value.available,
        'name': value.name,
    };
}

